import { render, staticRenderFns } from "./carousel-works.vue?vue&type=template&id=35a9d256&"
import script from "./carousel-works.vue?vue&type=script&lang=js&"
export * from "./carousel-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports